// src/components/Offers.js
import "./Offers.css";
import { Link } from "react-router-dom";
function Offers() {
  const offers = [
    { id: 1,
      image: "/assets/banner1.jpg",
      offerPer:"60% Off",
      name:"Wireless Device"
    },
    { id: 2,
      image: "/assets/banner2.jpg",
      offerPer:"60% Off",
      name:"Wired Earbuds"
    },
    { id: 3,
      image: "/assets/banner3.jpg",
      offerPer:"60% Off",
      name:"Smart Watches"
    },
  ];

  return (
    <section className="offers container-fluid px-md-5 py-5">
      <div className="row g-4">
        {offers.map((offer) => (
          <div key={offer.id} className="col-12 col-md-4">
            <div
              className="offer-card"
              style={{ backgroundImage: `url(${offer.image})` }}
            >
                <div className="row">
                    <div className="col-6"></div>
                    <div className="col-6 text-center p-4">
                        <div className="btn btn-outline-warning btn-lg px-4">{offer.offerPer}</div>
                        <h2 className="text-white fw-bold my-3">{offer.name}</h2>
                        <Link to="/products" className="btn btn-warning btn-lg px-4">
      Shop Now
    </Link>
                    </div>
                </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Offers;
